export default "__VITE_ASSET__xw9wrZ1J__"